import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry a client error. A 4xx is a verdict, not a hiccup — the
      // same request will get the same answer. Retrying was actively harmful
      // on 401: one expired session became four requests, each one taking the
      // interceptor's redirect-to-login path, which on its own is enough to
      // trip (or exhaust) the redirect-loop breaker in utils/authRedirect.
      // 408 and 429 are the exceptions: both explicitly mean "try again".
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status >= 400 && status < 500 && status !== 408 && status !== 429) {
          return false;
        }
        return failureCount < 3;
      },
      retryDelay: attempt =>
        Math.min(1000 * 2 ** attempt, 30000),

      refetchOnWindowFocus: false,

      staleTime: 1000 * 60 * 5,

      cacheTime: 1000 * 60 * 30
    },

    mutations: {
      retry: 1
    }
  }
});
